import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HowToWorkTogether from './components/HowToWorkTogether';
import DiscoverChapter from './components/DiscoverChapter';
import WhatIsSoulboard from './components/WhatIsSoulboard';
import PersonalSoulboardSection from './components/PersonalSoulboardSection';
import SoulboardExamples from './components/SoulboardExamples';
import CompleteJourneySection from './components/CompleteJourneySection';
import VideoSection from './components/VideoSection';
import HandsOnStyling from './components/HandsOnStyling';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import SprayBackground from './components/SprayBackground';
import StickyHeroPanel from './components/StickyHeroPanel';
import IntroScrollSection from './components/IntroScrollSection';
import TermsPage from './components/TermsPage';

const Home = () => {
  return (
    <div className="relative">
      <SprayBackground />
      <Header />
      <main className="relative" style={{ zIndex: 1 }}>
        <StickyHeroPanel />
        <IntroScrollSection />
        <HowToWorkTogether />
        <DiscoverChapter />
        <PersonalSoulboardSection />
        <SoulboardExamples />
        <CompleteJourneySection />
        <WhatIsSoulboard />
        <VideoSection />
        <HandsOnStyling />
        <GallerySection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <Toaster position="top-center" />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
